import React, { FC } from 'react';

export const CustomerThanksPage: FC = () => {
	return (
		<div>
			<div className="mt-10 fs-2 fw-bolder text-center">Thank you</div>
			<div className="mt-5 fs-6 w-450px text-center">We received your information, in case an order exist in our records you will receive an email to the email used on the order</div>
		</div>

	);
};
